'use strict';

const _=require('pulsar-utils/dist-es6/_');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

GroupsPopulationService=class GroupsPopulationService extends BaseService{
populate(groupTree,personIndex,personTransformFn=void 0){
return treeUtils.map(groupTree,group=>{
let keysToCopy=_.keys(group).filter(key=>key!=='personIds'&&key!=='children');
let populated=_.pick(group,keysToCopy);

populated.persons=group.personIds.
map(id=>personIndex[id]).
filter(person=>_.exists(person)).
map(p=>_.exists(personTransformFn)?personTransformFn(group,_.cloneDeep(p)):p);

return populated;
});
}};


module.exports=GroupsPopulationService;
//# sourceMappingURL=groupsPopulationService.js.map
